module.exports = __webpack_public_path__ + "static/media/edition_01.24f6a864.svg";